import React from 'react';
import { 
  Box, 
  Card, 
  Heading, 
  Image, 
  Stack, 
  Text, 
  HStack, 
  Badge, 
  Icon, 
  Flex,
  useColorModeValue
} from '@chakra-ui/react';
import { FaRupeeSign, FaCalendarAlt } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export default function ProductCardProfile({ad}) {
  const bgColor = useColorModeValue('white', 'gray.800');
  const borderColor = useColorModeValue('gray.200', 'gray.700');
  const hoverBg = useColorModeValue('gray.50', 'gray.700');
  const highlightColor = useColorModeValue('green.500', 'green.300');
  
  // Calculate days ago
  const createdAt = new Date(ad.createdAt);
  const now = new Date();
  const timeDiff = now.getTime() - createdAt.getTime();
  const daysAgo = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
  
  return (
    <Link to={`/preview_ad/${ad._id}`} style={{ textDecoration: 'none' }}>
      <Card 
        direction={{ base: 'column', sm: 'row' }}
        overflow='hidden'
        variant='outline'
        bg={bgColor}
        borderColor={borderColor}
        borderRadius="lg"
        transition="all 0.3s"
        _hover={{ 
          transform: 'translateY(-4px)', 
          boxShadow: 'md',
          borderColor: highlightColor
        }}
        h="100%"
      >
        <Image
          objectFit='cover'
          maxW={{ base: '100%', sm: '140px' }}
          src={ad.images && ad.images.length > 0 ? ad.images[0] : '/placeholder-image.jpg'}
          alt={ad.title}
        />

        <Stack flex={1} p={4}>
          <Box mb={2}>
            <HStack mb={1}>
              <Badge colorScheme="green" fontSize="xs">{ad.catagory}</Badge>
              {ad.quality && (
                <Badge 
                  colorScheme={ad.quality === 'A' ? 'green' : ad.quality === 'B' ? 'blue' : 'orange'}
                >
                  Grade {ad.quality}
                </Badge>
              )}
            </HStack>
            
            <Heading size='md' noOfLines={1}>{ad.title}</Heading>
            
            <Text py={1} color="gray.600" fontSize="sm" noOfLines={2}>
              {ad.description}
            </Text>
          </Box>

          <Flex mt="auto" justify="space-between" align="center">
            <HStack>
              <Icon as={FaRupeeSign} color={highlightColor} />
              <Text fontWeight="bold" fontSize="lg" color={highlightColor}>
                {ad.price}
                {ad.priceUnit && (
                  <Text as="span" fontSize="sm" color="gray.500" ml={1}>
                    /{ad.priceUnit}
                  </Text>
                )}
              </Text>
            </HStack>
            
            <HStack spacing={1}>
              <Icon as={FaCalendarAlt} color="gray.500" fontSize="xs" />
              <Text fontSize="xs" color="gray.500">
                {daysAgo === 0 ? 'Today' : daysAgo === 1 ? 'Yesterday' : `${daysAgo} days ago`}
              </Text>
            </HStack>
          </Flex>
          
          {ad.quantity && ad.unit && (
            <Text fontSize="sm" color="gray.500">
              Quantity: {ad.quantity} {ad.unit}
            </Text>
          )}
        </Stack>
      </Card>
    </Link>
  );
}
